<template>
	<BaseCmsPage @load="onPageLoad">
		<Body class="page-checkout" />
		<ClientOnly>
			<WebshopCheckout>
				<WebshopCheckoutWrapper>
					<BaseCmsLabel code="order_error_title" tag="h1" class="thank-you-title" />

					<BaseCmsLabel code="error_order_description" tag="div" class="wc-error-order" />
					<BaseCmsLabel code="thank_you_support" tag="div" class="thank-you-support" />

					<div class="thank-you-continue">
						<NuxtLink to="/" class="btn thank-you-continue-btn"><BaseCmsLabel code="thank_you_continue_shopping" /></NuxtLink>
					</div>
				</WebshopCheckoutWrapper>
			</WebshopCheckout>
			<template #fallback>
				<UiLoader class="spacing" />
			</template>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	const endpoints = useEndpoints();
	const { orderSuccess, orderData } = useCheckout();

	onMounted(() => {
		const url = window.location.href;
		const searchParams = new URL(url).searchParams;

		if(orderSuccess.value == 0 && searchParams.get('order_identificator')) {
			let urlId = searchParams.get('order_identificator');
			urlId = urlId.replace("|", '-').replace("|webshoporder", '');

			const webshopOrderId = endpoints.get('_get_hapi_webshop_order');
			const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", urlId);

			async function fetchOrderData() {
				await useApi(`${webshopOrder}`, {
					method: 'GET',
				}).then(async (res) => {
					orderData.value = res.data;
				});
			}

			fetchOrderData();
		}

		orderSuccess.value = 0;
	});

	//gtm
	const {gtmTrack} = useGtmBB();
	function onPageLoad(data) {
		if(!data) return;
		gtmTrack('virtualPageview', {
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>

<style lang="less" scoped>
	.thank-you-title{
		font-size: 24px; font-weight: bold; position: relative; padding: 0 0 16px 40px; text-wrap: pretty;
		@media (max-width: @m){font-size: 20px; padding-left: 37px;}
		&:before{
			.icon-warning(); font: 25px/1 var(--fonti); color: var(--orange); left: 0; top: 2px; position: absolute;
			@media (max-width: @m){font-size: 22px; top: 0;}
		}
	}
	.thank-you-support{
		background: #fff; border-radius: 12px; padding: 16px; margin: 30px 0; font-size: 15px;
		@media (max-width: @m){margin: 24px 0;}
		h3{padding: 0 0 10px; font-size: 18px; font-weight: bold;}
		p:last-child{padding-bottom: 0;}
	}
	.thank-you-continue{text-align: right;}
	.thank-you-continue-btn{
		min-width: 260px;
		@media (max-width: @m){min-width: 100%;}
	}
</style>
